const INITIAL_STATE = {
  data: {},
  errors: {},
          
}
const getFinalizeInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'FINALIZE_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'FINALIZE_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
          
export default getFinalizeInvoice;